export default __webpack_public_path__ + "static/media/pantry2-before1-768w.9d06e3ff.png";